import script from "./CustomModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__